/**
 * @description
 * - utility function to wrap a promise function and capture exceptions
 * - might seem silly, but needed to avoid eslint errors when using async functions in React components
 * - more infos can be found in this [article](https://github.com/orgs/react-hook-form/discussions/8020#discussioncomment-8226331)
 *
 * @example
 *
 * ```tsx
 *    <form onSubmit={withExceptionCapturing(handleSubmit(onSubmitHandler))}>
 * ```
 *
 * @param fn - promise function to execute
 * @param errorCallback - optional callback to handle errors
 */
export default function withExceptionCapturing<S, T extends unknown[]>(
  fn: (...rest: T) => Promise<S>,
  errorCallback?: (error: unknown) => void,
) {
  return (...args: T) => {
    fn(...args).catch((error: unknown) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
  };
}
